// Shared active forecast cycle for the forecasting module.
//
// v1 is single-cycle. Production sources the active cycle from the selected
// cycle on ForecastCycleHome (or central settings / SSO claims). Centralizing
// it here means a cycle roll-forward is a one-line change, not a hunt for
// hardcoded `'FY2027_BUDGET'` strings across pages. Pages may still override
// per-view via a `?cycle=` query param.
export const ACTIVE_CYCLE = 'FY2027_BUDGET';

export const resolveCycle = (override) => override || ACTIVE_CYCLE;
